<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title :class="['headline', dividerClass + '--text']">{{
          title
        }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-chip
          v-if="donneesConfidentiellesVisibles && !enModeCreation"
          color="secondary"
          outlined
          label
        >
          <v-avatar left>
            <v-icon>mdi-eye</v-icon>
          </v-avatar>

          Données confidentielles visibles
        </v-chip>
      </v-list-item-action>
      <v-list-item-action>
        <printButton />
      </v-list-item-action>
    </v-list-item>

    <v-card-text>
      <v-form lazy-validation ref="formHaut">
        <v-row dense>
          <v-col cols="12" md="4">
            <v-select
              return-object
              dense
              filled
              :items="listeCivilites"
              v-model="form.civilite"
              item-text="libelle"
              :label="$t('personnePhysique.detail.form.civilite')"
              :rules="[obligatoireRule(), serveurRule('civilite')]"
              :readonly="personnePhysiqueReadonly"
              hide-details="auto"
              :background-color="analyseDiff.color['civilite']"
              :hint="analyseDiff.hint['civilite']"
            >
              <template #selection="{ item }">
                {{ item.libelle }}
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              dense
              filled
              v-model="form.nom"
              :rules="[obligatoireRule(), serveurRule('nom')]"
              :label="$t('personnePhysique.detail.form.nom')"
              :readonly="personnePhysiqueReadonly"
              hide-details="auto"
              :background-color="analyseDiff.color['nom']"
              :hint="analyseDiff.hint['nom']"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              dense
              filled
              v-model="form.prenoms"
              :rules="[obligatoireRule(), serveurRule('prenoms')]"
              :label="$t('personnePhysique.detail.form.prenoms')"
              :readonly="personnePhysiqueReadonly"
              hide-details="auto"
              :background-color="analyseDiff.color['prenoms']"
              :hint="analyseDiff.hint['prenoms']"
            />
          </v-col>

          <v-col cols="12" md="6">
            <div class="d-flex align-start">
              <vue-tel-input-vuetify
                enabledCountryCode="true"
                mode="international"
                :prepend-inner-icon="
                  form.confidentialiteTelephone &&
                  !donneesConfidentiellesVisibles
                    ? 'mdi-phone-off'
                    : 'mdi-phone'
                "
                :disabled="
                  (form.confidentialiteTelephone &&
                    !donneesConfidentiellesVisibles) ||
                    personnePhysiqueReadonly
                "
                :v-mask="getmask(form.telephone)"
                :preferredCountries="['FR']"
                defaultCountry="FR"
                disabledFetchingCountry
                type="tel"
                dense
                filled
                v-model.trim="form.telephone"
                :rules="[serveurRule('telephone')]"
                :label="$t('personnePhysique.detail.form.telephone')"
                :readonly="personnePhysiqueReadonly"
                hide-details="auto"
                :background-color="analyseDiff.color['telephone']"
                :hint="analyseDiff.hint['telephone']"
              />
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-checkbox
                    v-on="on"
                    :readonly="personnePhysiqueReadonly"
                    v-model="form.smsAccepte"
                    label="Accepte les SMS"
                    :background-color="analyseDiff.color['smsAccepte']"
                    :hint="analyseDiff.hint['smsAccepte']"
                  />
                </template>
                <span>{{
                  form.smsAccepte ? 'SMS accepté' : 'SMS refusé'
                }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-checkbox
                    v-on="on"
                    :readonly="personnePhysiqueReadonly"
                    v-model="form.confidentialiteTelephone"
                    label="Confidentiel"
                    :background-color="
                      analyseDiff.color['confidentialiteTelephone']
                    "
                    :hint="analyseDiff.hint['confidentialiteTelephone']"
                  />
                </template>
                <span>{{
                  form.confidentialiteTelephone
                    ? 'Téléphone confidentiel'
                    : 'Téléphone public'
                }}</span>
              </v-tooltip>
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <div class="d-flex align-start">
              <v-text-field
                :prepend-inner-icon="
                  form.confidentialiteMail && !donneesConfidentiellesVisibles
                    ? 'mdi-email-off'
                    : 'mdi-email'
                "
                :disabled="
                  form.confidentialiteMail && !donneesConfidentiellesVisibles
                "
                dense
                filled
                :rules="[obligatoireRule(), serveurRule('mailPrincipal')]"
                v-model.trim="form.mailPrincipal"
                :label="$t('personnePhysique.detail.form.mailPrincipal')"
                :readonly="personnePhysiqueReadonly"
                hide-details="auto"
                :background-color="analyseDiff.color['mailPrincipal']"
                :hint="analyseDiff.hint['mailPrincipal']"
              />
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-checkbox
                    v-on="on"
                    :readonly="personnePhysiqueReadonly"
                    v-model="form.confidentialiteMail"
                    label="Confidentiel"
                    :background-color="analyseDiff.color['confidentialiteMail']"
                    :hint="analyseDiff.hint['confidentialiteMail']"
                  />
                </template>
                <span>{{
                  form.confidentialiteMail
                    ? 'Adresse mail confidentielle'
                    : 'Adresse mail publique'
                }}</span>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-divider :class="dividerClass" />
    </v-card-text>

    <v-list-item>
      <v-list-item-content two-line class="pt-0 pb-0">
        <v-list-item-title class="headline">
          <v-form lazy-validation ref="formContact">
            <v-input
              :rules="reglesContacts"
              dense
              hide-details="auto"
              class="headline"
            ></v-input>
          </v-form>
        </v-list-item-title>
      </v-list-item-content>

      <v-list-item-action
        v-if="afficherCarteVisitePossible && carteVisite != null"
      >
        <v-btn small outlined color="primary" @click="aficherCarte()"
          >afficher la carte de visite</v-btn
        >
      </v-list-item-action>

      <v-list-item-action v-if="CreerPersonneMoralePossible">
        <v-btn small outlined color="primary" @click="redirectPersonneMorale()"
          >créer une personne Morale</v-btn
        >
      </v-list-item-action>

      <v-dialog v-model="modalCarte">
        <v-card>
          <v-card-title> Carte de visite </v-card-title>
          <v-card-text>
            <v-img
              :cover="true"
              :src="`data:image/png;base64,${carteVisite}`"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="fermerModalCarteVisite" text>
              {{ $t('button.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-list-item-action v-if="ajouterContactPossible">
        <v-btn small outlined color="secondary" @click="ajouterContact('ajout')"
          >Lier à une nouvelle personne morale</v-btn
        >
      </v-list-item-action>

      <dialogRecherchePersonneMorale
        ref="dialogRecherchePersonneMorale"
        subtitle="Sélectionner une personne morale pour rajouter un nouveau contact"
        :lienVersDemande="true"
        @input="valideNouveauContact"
      />
    </v-list-item>

    <v-card-text>
      <v-tabs v-model="indexContact" show-arrows>
        <v-tab
          v-for="(contact, index) in contactsVisible"
          :key="`c${index}`"
          :disabled="disabledTabs[index]"
        >
          <v-badge
            :value="contact.invalid"
            color="error"
            left
            icon="mdi-alert-circle"
          >
            {{ contact.personneMorale.nomUsuel }}
          </v-badge>

          <v-btn
            v-visible="supprimerContactPossible"
            icon
            @click.stop="supprimerContact(index)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-tab>

        <v-tab-item
          v-for="(contact, index) in form.contacts"
          :key="'c' + index"
          eager
        >
          <editeurContact
            ref="contacts"
            :propositionAdresse="propositionAdresse"
            :adressePropose="adressePropose"
            :titreProposition="titreProposition"
            :readonly="control.readonly"
            :contact="contact"
            :personnephysique="form"
            :enums="enums"
            :donneesConfidentiellesVisibles="donneesConfidentiellesVisibles"
            :index="index"
            :analyseDiff="analyseDiff"
            @annulerSuppression="annulerSuppression($event)"
          />
        </v-tab-item>
      </v-tabs>
      <v-divider :class="dividerClass" />
    </v-card-text>

    <v-list-item
      v-if="
        !this.control.readonly &&
          !this.control.enDemandeSuppression &&
          !this.enModeReactivation &&
          this.control.edition === 'DIRECT'
      "
    >
      <v-list-item-content two-line class="pt-0 pb-0">
        <v-list-item-title class="headline">
          <v-form lazy-validation ref="formContact">
            <v-input
              :rules="reglesContacts"
              dense
              hide-details="auto"
              class="headline"
            ></v-input>
          </v-form>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content two-line class="pt-0 pb-0">
        <v-list-item-title class="headline">Droits d'accès</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-form lazy-validation ref="formBas">
      <v-card-text>
        <v-row dense>
          <v-col v-if="modifierIdentifiantPossible" cols="12" md="4">
            <v-tooltip bottom :disabled="personnePhysiqueReadonly">
              <template #activator="{ on }">
                <v-text-field
                  dense
                  filled
                  v-on="on"
                  v-model="form.identifiant"
                  :rules="[serveurRule('identifiant')]"
                  :label="$t('personnePhysique.detail.form.identifiant.title')"
                  :readonly="personnePhysiqueReadonly"
                  hide-details="auto"
                  :background-color="analyseDiff.color['identifiant']"
                  :hint="analyseDiff.hint['identifiant']"
                />
              </template>
              <span>
                {{ $t('personnePhysique.detail.form.identifiant.tooltip') }}
              </span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              return-object
              multiple
              dense
              filled
              :items="listeTypesAccesAgil"
              v-model="form.accesAgil"
              item-text="libelle"
              :label="$t('personnePhysique.detail.form.accesAgil')"
              :readonly="personnePhysiqueReadonly"
              :background-color="analyseDiff.color['accesAgil']"
              hide-details="auto"
            >
              <template #selection="{ item }">
                <v-chip
                  small
                  :color="
                    analyseDiff.color[`accesAgil[${item.id}]`] || 'secondary'
                  "
                >
                  <v-avatar
                    left
                    v-if="analyseDiff.supprime[`accesAgil[${item.id}]`]"
                  >
                    <v-btn
                      icon
                      @click.stop.capture="
                        annulerSuppression(`accesAgil[${item.id}]`)
                      "
                    >
                      <v-icon color="white">undo</v-icon>
                    </v-btn>
                  </v-avatar>

                  {{ item.libelle }}</v-chip
                >
              </template>
            </v-select>
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              return-object
              multiple
              dense
              filled
              :items="listeTypesAcces"
              v-model="form.acces"
              item-text="libelle"
              :label="$t('personnePhysique.detail.form.acces')"
              :readonly="personnePhysiqueReadonly"
              :background-color="analyseDiff.color['acces']"
              hide-details="auto"
            >
              <template #selection="{ item }">
                <v-chip
                  small
                  :color="analyseDiff.color[`acces[${item.id}]`] || 'secondary'"
                >
                  <v-avatar
                    left
                    v-if="analyseDiff.supprime[`acces[${item.id}]`]"
                  >
                    <v-btn
                      icon
                      @click.stop.capture="
                        annulerSuppression(`acces[${item.id}]`)
                      "
                    >
                      <v-icon color="white">undo</v-icon>
                    </v-btn>
                  </v-avatar>

                  {{ item.libelle }}
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-if="form.id">
        <footer-rgpd :form="this.form" genre="F" />
      </v-card-text>

      <slot name="zoneBasse" />
    </v-form>

    <slot />
  </v-card>
</template>

<script>
import EditeurContact from './EditeurContact';
import ServeurRule from '@/plugins/mixins/ServeurRule';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import { defaultDiff } from '@/utils/diff.js';
import { getmask } from '@/components/telephone/telephoneUtil';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';

export default {
  components: {
    editeurContact: EditeurContact,
    VueTelInputVuetify,
  },
  mixins: [ServeurRule, ValidationRules],
  inject: ['errors'],
  props: {
    propositionAdresse: {
      type: Boolean,
      default: false,
    },
    adressePropose: {
      type: String,
      default: null,
    },
    titreProposition: {
      type: String,
      default: null,
    },
    donneesConfidentiellesVisibles: {
      type: Boolean,
    },
    enums: {
      type: Object,
    },
    form: {
      type: Object,
    },
    control: {
      type: Object,
    },
    idContact: {
      type: Number,
    },
    edition: {
      type: String,
    },
    ajoutContactImpossible: {
      type: Boolean,
      default: false,
    },
    afficherCarteVisitePossible: {
      type: Boolean,
      default: false,
    },
    carteVisite: {
      type: String,
      default: null,
    },

    CreerPersonneMoralePossible: {
      type: Boolean,
      default: false,
    },
    pphReadonly: {
      type: Boolean,
      default: false,
    },
    enModeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    analyseDiff: {
      type: Object,
      default: defaultDiff,
    },
  },
  data() {
    return {
      modalCarte: false,
      indexContact: this.idContact,
    };
  },

  watch: {
    indexContact() {
      this.$emit('idContact', this.indexContact);
    },
    idContact() {
      this.indexContact = this.idContact;
    },
  },

  methods: {
    getmask,
    annulerSuppression(path) {
      this.$emit('annulerSuppression', path);
    },
    aficherCarte() {
      this.modalCarte = true;
    },
    redirectPersonneMorale() {
      this.$router.push({ name: 'creation/personnemorale' });
    },
    fermerModalCarteVisite() {
      this.modalCarte = false;
    },
    ajouterContact(type) {
      this.$refs.dialogRecherchePersonneMorale.show(type);
    },
    valideNouveauContact(personneMorale) {
      this.$emit('valideNouveauContact', personneMorale);
    },
    supprimerContact(index) {
      this.$emit('supprimerContact', index);
    },
    getForms() {
      //access aux formulaire à créer
      return [
        this.$refs.formHaut,
        this.$refs.formContact,
        this.$refs.formBas,
      ].concat(this.$refs.contacts);
    },
  },

  computed: {
    listeCivilites() {
      if (this.enums.civilites.length) {
        return this.enums.civilites;
      } else {
        const civilites = [];
        if (this.form && this.form.civilite) {
          civilites.push(this.form.civilite);
        }
        return civilites;
      }
    },
    modifierIdentifiantPossible() {
      return (
        this.$auth.mayNavigateTo({ name: 'workflow/demande' }) ||
        (!this.control.enDemandeModification && !this.control.enDemandeCreation)
      );
    },
    listeTypesAcces() {
      if (this.enums.typesAcces.length) {
        return this.enums.typesAcces;
      } else {
        var typesAcces = [];
        if (this.form && this.form.acces) {
          typesAcces = [...this.form.acces];
        }
        return typesAcces;
      }
    },

    listeTypesAccesAgil() {
      if (this.enums.typesAccesAgil.length) {
        return this.enums.typesAccesAgil;
      } else {
        var typesAccesAgil = [];
        if (this.form && this.form.accesAgil) {
          typesAccesAgil = [...this.form.accesAgil];
        }
        return typesAccesAgil;
      }
    },

    reglesContacts() {
      if (this.enModeCreation) {
        return [
          () =>
            this.form.contacts.length === 1 || 'Veuillez ajouter un contact',
        ];
      } else {
        return [];
      }
    },
    ajouterContactPossible() {
      if (this.enModeCreation) {
        return this.form.contacts.length === 0;
      }

      return (
        !this.control.readonly &&
        !this.control.enDemandeModification &&
        !this.control.enDemandeCreation &&
        !this.ajoutContactImpossible
      );
    },
    supprimerContactPossible() {
      if (!this.$listeners.supprimerContact) {
        return false;
      }
      if (this.enModeCreation) {
        return this.form.contacts.length === 1;
      }

      return (
        this.form.contacts.length > 1 &&
        !this.control.readonly &&
        !this.control.enDemandeModification &&
        !this.control.enDemandeCreation
      );
    },
    personnePhysiqueReadonly() {
      return this.control.readonly || this.pphReadonly;
    },
    disabledTabs() {
      const enDemandeModification =
        this.control.enDemandeModification || this.control.enDemandeCreation;
      return this.contactsVisible.map(
        (c, index) => enDemandeModification && this.indexContact !== index,
      );
    },
    contactsVisible() {
      if (!this.enModeReactivation) {
        return this.form.contacts.filter(c => !c.deleted);
      } else {
        return this.form.contacts.filter(c => c.deleted);
      }
    },
    dividerClass() {
      if (this.control.enDemandeAjoutContact) {
        return 'secondary';
      } else if (
        this.control.enDemandeModification ||
        (!this.control.readonly &&
          !this.control.enDemandeSuppression &&
          !this.enModeReactivation &&
          this.control.edition === 'DIRECT')
      ) {
        return 'accent';
      } else if (this.control.enDemandeSuppression) {
        return 'error';
      } else {
        return '';
      }
    },
    title() {
      if (this.control.enDemandeCreation) {
        return 'Contact : Demande de création';
      } else if (this.control.enDemandeModification) {
        return 'Contact : Demande de modification';
      } else if (
        !this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.enModeReactivation &&
        this.control.edition === 'DIRECT'
      ) {
        return 'Contact : Modification';
      } else if (this.control.enCreation) {
        return 'Contact : Création';
      } else if (this.control.enDemandeSuppression) {
        return 'Contact : Demande de suppression';
      } else {
        return 'Contact';
      }
    },
  },
};
</script>
